'use client'

export function PreClient() {
    return (
        <script dangerouslySetInnerHTML={{
            __html: `
                    try {
                        const root = window.document.documentElement;
                        const mode = (localStorage.getItem('theme') || 'system')
                        if (mode === 'system') {
                            const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
                            root.classList.add(systemTheme);
                            root.classList.remove(systemTheme === 'dark' ? 'light' : 'dark');
                        } else {
                            root.classList.add(mode);
                            root.classList.remove(mode === 'dark' ? 'light' : 'dark');
                        }
                    } catch (_) {}
                    `
        }} />
    )
}